<template>
    <centered :width="600">
        <owners-crud></owners-crud>
    </centered>
</template>

<script>
    import Centered from '../../layout/parts/Centered'
    import OwnersCrud from './owners/OwnersCrud';

    export default {

        components: {
            Centered, OwnersCrud
        }        
    }
</script>
